import React, { memo } from 'react';

import moment from 'moment';
import { useQuery } from '@tanstack/react-query';

import Table from '../../Table';

import ReportService from '../../../services/ReportService';
import formatBorrowerName from '../../../helpers/formatBorrowerName';

const cols = [
  {
    title: 'Effective Date',
    keys: ['date_effective'],
    format: (value) => moment(value).format('M/D/YY'),
    link: (row) => `/loans/${row.loan_id}/demands/${row.id}?tab=Demand`,
  },
  {
    title: 'Acceleration Date',
    keys: ['date_effective'],
    format: (value) => moment(value).add(30, 'days').format('M/D/YY'),
  },
  {
    title: 'Status',
    keys: ['status'],
    link: (row) => `/loans/${row.loan_id}/demands/${row.id}?tab=Demand`,
  },
  {
    title: 'Loan Number',
    keys: ['_loan.pixel_loan_number'],
    link: (row) => `/loans/${row._loan?.id}?tab=Loan`,
  },
  {
    title: 'Property',
    keys: ['_loan._property.address_line_1'],
  },
  {
    title: 'Borrower',
    keys: ['_loan._borrower_primary'],
    format: (borrower) => formatBorrowerName(borrower),
  },
];

function DemandsTable() {
  const { data: demands } = useQuery({
    queryKey: ['demandsReport'],
    queryFn: ReportService.getDemandsReport,
  });

  return <Table cols={cols} rows={demands} title="Demands" />;
}

export default memo(DemandsTable);
